import { Suspense, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ProfileModal } from '@/components/modals/ProfileModal';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';

function PageFallback() {
  return (
    <div
      style={{
        minHeight: '40vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--dim)',
        fontSize: 13,
        fontWeight: 700,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
      }}
    >
      Loading…
    </div>
  );
}

export function Layout() {
  const [profileOpen, setProfileOpen] = useState(false);
  const location = useLocation();
  return (
    <>
      <Header onProfileClick={() => setProfileOpen(true)} />
      <main className="app-main">
        <ErrorBoundary key={location.pathname}>
          <Suspense fallback={<PageFallback />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </main>
      <Footer />
      <ProfileModal open={profileOpen} onClose={() => setProfileOpen(false)} />
    </>
  );
}
